import { useEffect, useState } from 'react'

import { DialogProps } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'
import { Textarea } from '@fortem-monorepo/react-ui'

export interface ImportCommandModalProps extends DialogProps {
  onImport: (command: string) => void
}

export const ImportCommandModal: React.FC<ImportCommandModalProps> = ({
  children,
  onImport,
  ...props
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (props.open) {
      setValue('')
    }
  }, [props.open])

  return (
    <Dialog {...props}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Import a custom command</DialogTitle>
        </DialogHeader>
        <Textarea className={''} value={value} onChange={(e) => setValue(e.target.value)} />
        {children}
        <DialogFooter>
          <Button
            type="button"
            size="sm"
            variant={'destructive'}
            onClick={() => {
              props.onOpenChange && props.onOpenChange(false)
            }}
          >
            Cancel
          </Button>
          <Button
            type="button"
            size="sm"
            onClick={() => {
              onImport(value)
            }}
            disabled={!value}
          >
            Import
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
